// Shared API-error formatter (PR 7): turns any axios error into a readable
// sentence for learner/admin-facing notices. FastAPI returns `detail` either
// as a string (HTTPException) or as a list of validation-error objects (422),
// which used to render as "[object Object]" in the Add Learner dialog.
export default function formatApiError(error) {
  const detail = error?.response?.data?.detail;

  if (typeof detail === 'string' && detail.trim()) {
    return detail;
  }

  if (Array.isArray(detail)) {
    const lines = detail
      .map((item) => {
        if (typeof item === 'string') return item;
        const field = Array.isArray(item?.loc)
          ? item.loc.filter((part) => part !== 'body' && typeof part === 'string').join('.')
          : '';
        const message = typeof item?.msg === 'string' ? item.msg : '';
        if (field && message) return `${field}: ${message}`;
        return message || null;
      })
      .filter(Boolean);
    if (lines.length > 0) {
      return lines.join('\n');
    }
  }

  return 'Something went wrong. Please try again in a moment.';
}
